/**
 * Created by ott on 27.06.17.
 */
// Функция отправляет в таблицу action запись события о подписке/отписке пользователя,
// в данный момент не используется, удалять зассал =(


if(document.getElementById('settings-subscribe')){

    var subscribes = {
        logUserSubscribes: function (list) {
            var form = $("#subscribe-form").serializeArray();
            var checked = [];
            $.map(form, function (val) {
                match = val.name.match(/\d+/);
                if (match != null) {
                    checked.push(parseInt(match[0]));
                }
            });

            while (list.length > 0) {
                var item = list.shift();

                if (item[2] === undefined && $.inArray(item[0], checked) !== -1) {
                    sendEvent.action(item[1] + ' subscribe', item[0], 'subscribe');
                }
                if (item[2] !== undefined && $.inArray(item[0], checked) === -1){
                    sendEvent.action(item[1] + ' unsubscribe', item[0], 'subscribe');
                }

            }
        }
    }
}